import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private active = signal(0);
  readonly isLoading = computed(() => this.active() > 0);

  start() {
    this.active.set(this.active() + 1);
  }

  end() {
    const next = this.active() - 1;
    this.active.set(next < 0 ? 0 : next);
  }
}
